import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useCostSource from "./hooks/useCostSource";

const CostSource = () => {
  const costSourceData = useCostSource();
  return (
    <div class="container container-fluid">
      <div className="header-section">
        <h1>
          {costSourceData.screen_title} -{" "}
          <span className="heading-cod">{costSourceData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={costSourceData.formFields}
        dropdownValues={costSourceData.dropdownValues}
        paramsData={costSourceData.paramsData}
        updataParamData={costSourceData.updateParamData}
      />
      <ButtonsSection ctaButtons={costSourceData.ctaButtons} />
      <DisplayTable
        data={costSourceData.data}
        parmKey={costSourceData.parmKey}
        menuOptions={costSourceData.menuOptions}
        tableHeaders={costSourceData.columnDef}
        setRowData={costSourceData.setRowData}
        selectedPriceSchedules={costSourceData.selectedRows}
        setSelectedPriceSchedules={costSourceData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={costSourceData.first}
          rows={costSourceData.rows}
          totalRecords={costSourceData.totalRecords}
          currentPage={costSourceData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={costSourceData.onPageChange}
        />
      </div>
      {costSourceData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={costSourceData.isConfirmationModalOpen}
          onRequestClose={costSourceData.closeConfirmationModal}
          onBack={costSourceData.closeConfirmationModal}
          onSave={costSourceData.deleteCostSource}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={costSourceData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default CostSource;
